import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const poechangetableApi = api
  .enhanceEndpoints({ addTagTypes: ['POEChangeTable'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOEChangeTables: builder.query<po_mproduct[], any>({
        query: ({ cid, olid }) => `poechangetable/${cid}/${olid}`,
        providesTags: ['POEChangeTable']
      }),
      getPOEChangeTableById: builder.query<po_mproduct, string>({
        query: id => `poechangetable/byid/${id}`,
        providesTags: ['POEChangeTable']
      }),
      importPOEChangeTable: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `poechangetable/import`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['POEChangeTable']
      }),
      insertPOEChangeTable: builder.mutation({
        query: poechangetable => ({
          url: `poechangetable/`,
          method: 'POST',
          body: poechangetable
        }),
        invalidatesTags: ['POEChangeTable']
      }),
      updatePOEChangeTable: builder.mutation({
        query: poechangetable => ({
          url: `poechangetable/`,
          method: 'PUT',
          body: poechangetable
        }),
        invalidatesTags: ['POEChangeTable']
      }),
      deletePOEChangeTable: builder.mutation({
        query: poechangetable => ({
          url: `poechangetable/${poechangetable.ct_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POEChangeTable']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOEChangeTablesQuery,
  useGetPOEChangeTableByIdQuery,
  useImportPOEChangeTableMutation,
  useInsertPOEChangeTableMutation,
  useUpdatePOEChangeTableMutation,
  useDeletePOEChangeTableMutation
} = poechangetableApi;

